import styles from './styles.module.css'

export default function DescriptionPaTool({dict}) {
    const { description_pa_tool_1, description_pa_tool_2 } = dict.discover;
    return (
        <section className={styles.description_pa_tool}>
            <p>{description_pa_tool_1}</p>
            <p>{description_pa_tool_2}</p>
        </section>
    );
}